// import {} from '@tma.js/sdk'
import Vue, { Ref, getCurrentInstance } from 'vue';
import { generateUUID } from '@/common/utils';

let tgInviteLink: string = "https://t.me/+CP084ol7tohmYmFl"

export const isTMA = () => {
    const locationHash = location?.hash?.toString()|| "";
    const _isTMA: boolean = locationHash.includes("tgWebAppData")
    return _isTMA
}

// 页面挂载执行
export const initTg = ( onloaded: () => void) => {
    // const tgScript = document.head.querySelector('script[src="https://telegram.org/js/telegram-web-app.js"]') as HTMLScriptElement;
    if (!isTMA()) {
        return;
    }
    const tgScript = document.createElement('script')
    tgScript.src = "https://telegram.org/js/telegram-web-app.js"
    document.head.appendChild(tgScript)
    if ((window as any).Telegram !== undefined) {
        const {ready} = useTelegram()
        ready()
        onloaded()
        console.log("tg miniApp: ", "ts script loaded when initialization")
        return;
    }
    tgScript.onload = function() {
        const {ready} = useTelegram()
        ready()
        onloaded()
        console.log("tg miniApp: ", "tg script is loaded")
    }
}

export const tgNetworkHelper = () => {
    const { proxy } = getCurrentInstance() as { proxy: any }
    const tgMiniAppStartup = async () => {
        const { user } = useTelegram()
        if (!user?.id) {
            console.log("tg miniApp: ", "upload ts startup but user-id is nil")
            return
        }
        const { result, errorMsg, data } = await proxy.$axios.$$post('overseaAPI::/rest/o/w/pwa/tg/startup', {
            telegramUid: user?.id || ""
            // telegramUid: "5007755080"
        })
    
        if (result === 1) {
            if (data?.telegramGroupInviteLink) {
                tgInviteLink = data?.telegramGroupInviteLink
            }
            console.log("tg miniApp: ", "startup interface success")
        }
    }
    
    const tgPraiseAmountList = async () => {
        console.log("tg miniApp: ", "tg fetch praise amount list")
        await proxy.$store.dispatch('initTgPraiseAmounts', { $axios: proxy.$axios, route: proxy.$route })
    }

    const createTgWalletOrder = async (amount: string) => {
        const { user, openTelegramLink } = useTelegram()
        // curl -X POST -H "Wpay-Store-Api-Key: SbKrJeCONjgU9jI7TC4L6dtU7qUpWINVBXdz" -H "Content-Type: application/json" -H "Accept:application/json" -d '{"amount":{"amount":"0.1","currencyCode":"USD"},"autoConversionCurrency":"USDT","externalId":"te","timeoutSeconds":10800,"description":"VPN for 1 month","returnUrl":"https://t.me/wallet","failReturnUrl":"https://t.me/wallet","customData":"unknown","customerTelegramUserId":"5007755080"}' https://pay.wallet.tg/wpay/store-api/v1/order
        const headers = {
            // 'Wpay-Store-Api-Key': walletKey,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
        const bodyData = {
            "amount": {amount, "currencyCode": "USD"},
            "autoConversionCurrency": "USDT",
            "externalId":"ORD-" + generateUUID(),
            "timeoutSeconds": 10800,
            "description": "Create a wallet order",
            "customData": "unknown",
            "customerTelegramUserId": user?.id
        }
        
        // https://pay.wallet.tg/wpay/store-api/v1/orde 实际由服务端请求这个接口
        const { status, message, data } = await proxy.$axios.$$post('overseaAPI::/rest/o/group/tg/order/create',bodyData ,{headers})
        console.log("tg miniApp: ", "create tg order result: " + status + message + data)
        if (status === "SUCCESS") {
            if (data?.directPayLink) {
                openTelegramLink(data?.directPayLink)
            }
        }
    }
    return {tgMiniAppStartup, createTgWalletOrder, tgPraiseAmountList}
}

const parseJsonSatefy = <T = unknown>(str?: string) => {
    try { 
        if(typeof str !== 'string') {
            return undefined;
        } 
        return JSON.parse(str) as T 
    } catch { 
        return undefined 
    }
}

// tg快捷实例
export const useTelegram = () =>  {
    const webApp = (window as any).Telegram?.WebApp
    const webView = (window as any).Telegram?.WebView
    console.log("tg miniApp:  \n", "webApp" + JSON.stringify(webApp) + '\n' +  "webView" + JSON.stringify(webView))
    
    let user = webApp?.initDataUnsafe?.user
    if (user === undefined || user === null) {
    // note: %7B%22id%22%3A5007755080%2C%22first_name%22%3A%22Qi%22%2C%22last_name%22%3A%22Xin%22%2C%22language_code%22%3A%22zh-hans%22%2C%22allows_write_to_pm%22%3Atrue%7D
       if (webView?.initParams?.user) {
            const userStr = decodeURIComponent(webView?.initParams?.user)
            if (userStr !== undefined) {
                user = parseJsonSatefy<string>(userStr)
                console.log("tg miniApp: ","parse user info from webview: " + userStr)
            }
        }
    }   
    /**
    * Informs the Telegram app that the Web App is ready to be displayed.
    */
    const ready = () => {
        webApp?.ready()
        webApp?.expand()
        webApp?.enableClosingConfirmation()
    }

    const openLink = (url: string) => {
        console.log("tg miniApp: ", 'Telegram webapp Open URL: {url}')
        webApp?.openLink(url, {try_instant_view: true})
    }

    const openTelegramLink = (url: string) => {
        console.log("tg miniApp: ", 'Telegram webapp Open Telegram URL: {url}')
        webApp?.openTelegramLink(url)
    }

    const openGroup = () => {
        console.log("tg miniApp: ", "tglog openGroup" + tgInviteLink)
        webApp?.openTelegramLink(tgInviteLink)
    }

    return {
        user,
        isTMA,
        ready,
        openLink,
        openTelegramLink,
        openGroup,
        parseJsonSatefy,
        // onArgumentResult,
        // onResult,
        // onReceivedEvent,
        // executeArgumentMethod,
        // executeMethod
    }
}